import React from 'react';
import {
  Typography,
  Box,
  Avatar,
  Grid,
  Link
} from '@mui/material';
import { useNavigate } from "react-router-dom";
import ArtworksComponent from '../Components/ArtworksComponent';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import LanguageIcon from '@mui/icons-material/Language';
import FacebookIcon from '@mui/icons-material/Facebook';
// Kept for the disabled header block in the render below — see the note there.
// eslint-disable-next-line no-unused-vars
import BackHeader from '../Components/BackHeader';

const ArtistProfile = ({ artist,userProfile,profileId }) => {
  const navigate = useNavigate();
  const store = artist?.store?.slice(0,9);
  const studio = artist?.studio?.slice(0,9);

  const userProfileName = (() => {
    const displayName = userProfile?.displayName?.trim();
    if (displayName) {
      const parts = displayName.split(" ");
      if (parts[1]) return parts[1];   // ✅ last name exists
      if (parts[0]) return parts[0];   // ✅ fallback to first name
    }
    // ✅ fallback if displayName is missing
    return artist?.artist?.lastName || artist?.artist?.firstName || "";
  })();

  // Unused only because its call site in the render below is commented out.
  // eslint-disable-next-line no-unused-vars
  const renderProfileHeader = () => {
    const profile = artist?.artist;
    if (!profile) return null;

    return (
      <Box mb={5}>
        <Grid container spacing={3} alignItems="center">
          <Grid item>
            <Avatar
              src={profile.profilePicture}
              sx={{ width: 100, height: 100, borderRadius: '50%', borderColor: 'white', borderWidth: 1 }}
            />
          </Grid>

          <Grid item xs>
            <Typography variant="h5" sx={{ fontWeight: 600, fontFamily: 'basic-sans' }}>
              {profile.firstName} {profile.lastName}
            </Typography>
            <Typography variant="body2" sx={{ color: '#888' }}>
              @{profile.userName}
            </Typography>

            <Typography variant="body2" sx={{ mt: 1, fontFamily: 'basic-sans' }}>
              Followers {profile.followedCount || 0} | Following {profile.followingCount || 0}
            </Typography>
          </Grid>
        </Grid>

        {profile.biography && (
          <Typography variant="body1" sx={{ mt: 2, color: '#ccc', fontFamily: 'basic-sans' }}>
            {profile.biography}
          </Typography>
        )}

        <Box display="flex" gap={2} mt={2}>
          {profile?.socialMedia?.twitterHandle && (
            <Link href={profile?.socialMedia?.twitterHandle} target="_blank" rel="noopener noreferrer">
              <TwitterIcon sx={{ color: '#1DA1F2' }} />
            </Link>
          )}
          {profile?.socialMedia?.facebookProfile && (
            <Link href={profile?.socialMedia?.facebookProfile} target="_blank" rel="noopener noreferrer">
              <FacebookIcon sx={{ color: '#1877F2' }} />
            </Link>
          )}
          {profile?.socialMedia?.instagramProfile && (
            <Link href={profile?.socialMedia?.instagramProfile} target="_blank" rel="noopener noreferrer">
              <InstagramIcon sx={{ color: '#E4405F' }} />
            </Link>
          )}
          {profile?.socialMedia?.websiteAddress && (
            <Link href={profile?.socialMedia?.websiteAddress} target="_blank" rel="noopener noreferrer">
              <LanguageIcon sx={{ color: 'white' }} />
            </Link>
          )}
        </Box>
      </Box>
    );
  };

  return (
    <Box>
      {/* DISABLED: the profile header and back link are commented out here, so
          renderProfileHeader and BackHeader above are reported unused. They are
          kept deliberately — restore these two lines to bring the header back. */}
      {/* <BackHeader /> */}
      {/* {renderProfileHeader()} */}

        <>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography
              variant="h4"
              gutterBottom
              sx={{
                fontFamily: "basic-sans",
                fontWeight: "normal",
                marginRight: 2,
              }}
            >
               {profileId && !userProfileName ?  "My Store" : userProfileName + "'s Store"}
            </Typography>
            {artist?.store?.length > 9 &&
              <Link
                component="button"
                underline="none"
                onClick={() => navigate("/marketplace/artworks", { state: { artist: artist,userProfileName:userProfileName, isStore: true, isStudio: false } })}
                sx={{
                  fontFamily: "basic-sans",
                  fontWeight: "normal",
                  marginRight: 2,
                  fontSize: "1.2em",
                  color: "red",
                  cursor: "pointer",
                  "&:hover": {
                    textDecoration: "underline",
                  },
                }}
              >
                View All
              </Link>
            }
          </Box>
          {store?.length > 0 ? (
          <ArtworksComponent artworks={store} />
          )
          :
            <Typography gutterBottom sx={{ fontFamily: "basic-sans", }}>
              No record found
            </Typography>
          }
        </>

     
        <>
          <Box sx={{ display: "flex", alignItems: "center", mt: 5 }}>
            <Typography
              variant="h4"
              gutterBottom
              sx={{
                fontFamily: "basic-sans",
                fontWeight: "normal",
                marginRight: 2,
              }}
            >
              {profileId && !userProfileName ?  "My Studio" : userProfileName + "'s Studio"}
            </Typography>

            {artist?.studio?.length > 9 &&
              <Link
                component="button"
                underline="none"
                onClick={() => navigate("/marketplace/artworks", { state: { artist: artist,userProfileName:userProfileName, isStore: false, isStudio: true } })}
                sx={{
                  fontFamily: "basic-sans",
                  fontWeight: "normal",
                  marginRight: 2,
                  fontSize: "1.2em",
                  color: "red",
                  cursor: "pointer",
                  "&:hover": {
                    textDecoration: "underline",
                  },
                }}
              >
                View All
              </Link>
            }
          </Box>
        {studio?.length > 0 ? (
          <ArtworksComponent artworks={studio} />
        )
          :
          <Typography gutterBottom sx={{ fontFamily: "basic-sans", }}>
            No record found
          </Typography>
        }
        </>
    </Box>
  );
};

export default ArtistProfile;
